import { removeComposeLinkViewState } from '../actions/internalActions';
import { deleteLink } from 'owa-link-data';
import * as ReactDOM from 'react-dom';
import { orchestrator } from 'satcheljs';

orchestrator(deleteLink, actionMessage => {
    const linkDOMElement = document.getElementById(actionMessage.linkId);
    if (!linkDOMElement) {
        return;
    }

    ReactDOM.unmountComponentAtNode(linkDOMElement);
    linkDOMElement.remove();
    removeComposeLinkViewState(actionMessage.linkId);
});
